import _Vue from 'vue'
import AbstractWeatherService from '@/utilities/weather/services/abstracts/AbstractWeatherService'
import WeatherService from '@/utilities/weather/WeatherService'

export type WeatherPluginOptionType = {
  services: AbstractWeatherService[]
}

export default {
  install(Vue: typeof _Vue, { services }: WeatherPluginOptionType) {
    Vue.prototype.$weather = new WeatherService(...services)
  },
}
